<template>
  <div class="modal fade" id="createNewSchoolModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            New School
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p v-if="errorMessage != ''">{{errorMessage}}</p>
          <form @submit.prevent="createSchool" key="name">
            <div class="form-group">
              <label for="createSchoolName">School Name</label>
              <input
                type="text"
                class="form-control"
                id="createSchoolName"
                placeholder="Name"
                v-model="newSchoolName"
                required
              />
            </div>
            <div class="text-right">
              <button type="submit" class="btn btn-primary">
                Create School
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Parse from "parse";

export default {
  name: "CreateNewSchoolModal",
  props: {
  },
  data() {
    return {
      newSchoolName: "",
      errorMessage: ""
    };
  },
  async mounted() {
    $("#createNewSchoolModal").on(
      "shown.bs.modal",
      function() {
        $("#createSchoolName").focus();
      }
    );
  },
  methods: {
    async createSchool() {
      $("#createNewSchoolModal").modal("hide");
      var view = this;
      view.$store.commit("updateLoading", true);
      var user = Parse.User.current();
      Parse.Cloud.run("createSchool", { objectId:user.id, schoolName:view.newSchoolName }).then(function(result) {
          console.log("result :" + JSON.stringify(result))
          view.$emit("school-created");
          view.$store.commit("updateLoading", false);
      }, function(error) {
          console.log(error);
          view.errorMessage = "Something went wrong. Please try again.";
          $("#createNewSchoolModal").modal("show");
          view.$store.commit("updateLoading", false);
      });
    },
    clearFields() {
      this.newSchoolName = "";
      this.errorMessage = "";
    }
  }
}
</script>
